/* eslint-disable import/prefer-default-export */

import {
  addDays,
  startOfWeek,
  endOfWeek,
  addWeeks,
  startOfMonth,
  endOfMonth,
  addMonths,
} from 'date-fns';

// eslint-disable-next-line no-unused-vars
// import { DefinedRange } from './types';

const getDefaultRanges = (date) => [
  {
    label: '今日',
    startDate: date,
    endDate: date,
  },
  {
    label: '昨日',
    startDate: addDays(date, -1),
    endDate: addDays(date, -1),
  },
  {
    label: '本周',
    startDate: startOfWeek(date),
    endDate: endOfWeek(date),
  },
  {
    label: '上周',
    startDate: startOfWeek(addWeeks(date, -1)),
    endDate: endOfWeek(addWeeks(date, -1)),
  },
  {
    label: '近七天',
    startDate: addWeeks(date, -1),
    endDate: date,
  },
  {
    label: '本月',
    startDate: startOfMonth(date),
    endDate: endOfMonth(date),
  },
  {
    label: '上月',
    startDate: startOfMonth(addMonths(date, -1)),
    endDate: endOfMonth(addMonths(date, -1)),
  },
];



export const defaultRanges = getDefaultRanges(new Date());
